/**
 * Исход сравнения объявлений команд (как в finishRoundScoring / END_DECLARE hardcore).
 *
 * Сбор комбо по местам совпадает с `teamDeclaredCombos` в `engine.js` и `compareTeams`
 * в `shared/game/belot/armenian/declarations.js`.
 *
 * @module game/belotArmenian/resolveDeclarationBattleOutcome
 */

const {
  detectCombinations,
  compareTeams,
  declarationComboKey,
} = require('../../shared/game/belot/armenian/declarations');

/**
 * Нужны все четыре руки по 8 карт (онлайн-снапshot часто без полного набора — тогда не фильтруем UI).
 * @param {unknown} hands
 * @returns {boolean}
 */
function hasFullHandsSnapshot(hands) {
  if (!Array.isArray(hands) || hands.length !== 4) return false;
  return hands.every((row) => Array.isArray(row) && row.length === 8);
}

/**
 * @param {number[][]|null|undefined} handsAtRoundStart
 * @param {[string[], string[], string[], string[]]|null|undefined} declaredComboKeysBySeat
 * @param {number} seat
 */
function teamDeclaredCombosForSeat(handsAtRoundStart, declaredComboKeysBySeat, seat) {
  const hand = Array.isArray(handsAtRoundStart) ? handsAtRoundStart[seat] : null;
  if (!Array.isArray(hand) || hand.length !== 8) return [];
  const all = detectCombinations(hand);
  const declaredSet = new Set(Array.isArray(declaredComboKeysBySeat?.[seat]) ? declaredComboKeysBySeat[seat] : []);
  /** @type {import('../../shared/game/belot/armenian/declarations').BelotDeclaration[]} */
  const out = [];
  for (const combo of all) {
    if (declaredSet.has(declarationComboKey(combo))) out.push(combo);
  }
  return out;
}

/**
 * @param {any} state — снимок движка с полями handsAtRoundStart, declaredComboKeysBySeat, contract
 * @returns {{ outcome: 'team_a'|'team_b'|'tie' }|null}
 */
function resolveDeclarationBattleOutcome(state) {
  if (!state || typeof state !== 'object') return null;
  const h = state.handsAtRoundStart ?? state.hands;
  const rows = state.declaredComboKeysBySeat;
  const c = state.contract;
  if (!hasFullHandsSnapshot(h)) return null;
  if (!Array.isArray(rows) || rows.length !== 4) return null;
  if (!c || !Object.prototype.hasOwnProperty.call(c, 'trumpSuit')) return null;

  const trumpSuit = c.trumpSuit;
  const aCombos = [
    ...teamDeclaredCombosForSeat(h, rows, 0),
    ...teamDeclaredCombosForSeat(h, rows, 2),
  ];
  const bCombos = [
    ...teamDeclaredCombosForSeat(h, rows, 1),
    ...teamDeclaredCombosForSeat(h, rows, 3),
  ];

  if (aCombos.length === 0 && bCombos.length === 0) return { outcome: 'tie' };

  const res = compareTeams(aCombos, bCombos, trumpSuit);
  return { outcome: res.outcome };
}

module.exports = {
  resolveDeclarationBattleOutcome,
  teamDeclaredCombosForSeat,
  hasFullHandsSnapshot,
};
